var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVeliRehberlik = function SvgVeliRehberlik(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4330_4055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6338 197.5C94.3404 197.5 107.884 183.957 107.884 167.25C107.884 150.543 94.3404 137 77.6338 137C60.9272 137 47.3838 150.543 47.3838 167.25C47.3838 183.957 60.9272 197.5 77.6338 197.5Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 242.833C23 220.558 41.0578 202.5 63.3333 202.5H91.5667C113.842 202.5 131.9 220.558 131.9 242.833C131.9 253.971 122.871 263 111.733 263H43.1667C32.0289 263 23 253.971 23 242.833Z",
    fill: "url(#paint0_linear_4330_4055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.634 197.5C239.34 197.5 252.884 183.957 252.884 167.25C252.884 150.543 239.34 137 222.634 137C205.927 137 192.384 150.543 192.384 167.25C192.384 183.957 205.927 197.5 222.634 197.5Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 242.833C168 220.558 186.058 202.5 208.333 202.5H236.567C258.842 202.5 276.9 220.558 276.9 242.833C276.9 253.971 267.871 263 256.733 263H188.167C177.029 263 168 253.971 168 242.833Z",
    fill: "url(#paint1_linear_4330_4055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.69 213.167C163.438 213.167 173.773 202.832 173.773 190.083C173.773 177.335 163.438 167 150.69 167C137.941 167 127.606 177.335 127.606 190.083C127.606 202.832 137.941 213.167 150.69 213.167Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 247.76C109 230.762 122.78 216.982 139.778 216.982H161.322C178.32 216.982 192.1 230.762 192.1 247.76C192.1 256.259 185.21 263.149 176.711 263.149H124.389C115.89 263.149 109 256.259 109 247.76Z",
    fill: "url(#paint2_linear_4330_4055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5688 93.211C79.4509 90.1027 76.9764 86.4102 75.2869 82.3447C73.5974 78.2792 72.7261 73.9205 72.7227 69.5179C72.7193 65.1153 73.5839 60.7552 75.2672 56.6871C76.9504 52.619 79.4192 48.9227 82.5323 45.8096C85.6454 42.6965 89.3417 40.2277 93.4098 38.5445C97.4779 36.8613 101.838 35.9966 106.241 36C110.643 36.0034 115.002 36.8748 119.067 38.5643C123.133 40.2537 126.825 42.7282 129.934 45.8461L197.437 113.35L161.979 148.808C155.402 155.385 144.742 155.385 138.166 148.808L82.5688 93.211Z",
    fill: "#2B81FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.709 113.35L170.212 45.8461C173.321 42.7282 177.013 40.2537 181.079 38.5643C185.144 36.8748 189.503 36.0034 193.906 36C198.308 35.9966 202.668 36.8613 206.736 38.5445C210.804 40.2277 214.501 42.6965 217.614 45.8096C220.727 48.9227 223.196 52.619 224.879 56.6871C226.562 60.7552 227.427 65.1153 227.423 69.5179C227.42 73.9205 226.549 78.2792 224.859 82.3447C223.17 86.4102 220.695 90.1027 217.577 93.211L161.98 148.808C155.403 155.385 144.744 155.385 138.167 148.808L102.709 113.35Z",
    fill: "url(#paint3_linear_4330_4055)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.894 103.02C212.392 103.02 227.387 88.0247 227.387 69.5275C227.387 51.0303 212.392 36.0354 193.894 36.0354C175.397 36.0354 160.402 51.0303 160.402 69.5275C160.402 88.0247 175.397 103.02 193.894 103.02Z",
    fill: "#2B81FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4055",
    x1: 131.881,
    y1: 202.503,
    x2: 80.5236,
    y2: 294.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4330_4055",
    x1: 276.881,
    y1: 202.503,
    x2: 225.524,
    y2: 294.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4330_4055",
    x1: 192.086,
    y1: 216.984,
    x2: 152.895,
    y2: 287.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4330_4055",
    x1: 227.402,
    y1: 36.0054,
    x2: 109.879,
    y2: 160.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4330_4055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
};
export default SvgVeliRehberlik;